"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectLoadingState = void 0;
const react_1 = __importDefault(require("react"));
const Spinner_1 = require("../../../../Spinner/Spinner");
const SelectLoadingState_styles_1 = require("./SelectLoadingState.styles");
const SelectLoadingState = (props) => {
    return (react_1.default.createElement(SelectLoadingState_styles_1.StyledLoading, { role: "option" },
        react_1.default.createElement(Spinner_1.Spinner, { dimension: "small" }),
        react_1.default.createElement(SelectLoadingState_styles_1.StyledText, null, props.loadingText)));
};
exports.SelectLoadingState = SelectLoadingState;
//# sourceMappingURL=SelectLoadingState.js.map